import { List } from '@mui/material'
import React, { useMemo } from 'react'
import TextEvent from './scanHistoryComponents/TextEvent';
import { Machine } from '../../../ts/Connections';
import { TextEventProps, MachineEvent } from '../../../ts/MachineEvent';
import { Cargo } from '../../../ts/Cargo';
import ScanSkeleton from './scanHistoryComponents/ScanSkeleton';
import TextScanEvent from './scanHistoryComponents/TextScanEvent';

interface ScanHistoryProps {
    selectedScanIndex: number;
    setSelectedScanIndex: (index: number) => void;
    cargoResponses: Cargo[];
    machineEvents: MachineEvent[];
    setOpenScanDetails: (open: boolean) => void;
    machine: Machine;
}

function ScanHistory(props: ScanHistoryProps) {
    const { selectedScanIndex, setSelectedScanIndex, cargoResponses, machineEvents, setOpenScanDetails, machine } = props

    // Create a combined timeline of machine events and scan events (and sort by timestamp)
    const timelineEvents = useMemo(() => {
        return [...machineEvents, ...cargoResponses].sort((a, b) => b.timeStamp.getTime() - a.timeStamp.getTime());
    }, [machineEvents, cargoResponses]);

    const handleListItemClick = (
        _event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
    ) => {
        setSelectedScanIndex(index);
    };

    const openDetailsModal = function () {
        console.log('Scan Details Modal Disabled on Medium view')
    }

    return (
        <List>
            {
                timelineEvents.map((historyEvent, index) => {
                    if (historyEvent instanceof Cargo) {
                        return (
                            <TextScanEvent
                                key={index}
                                scanFailure={historyEvent.dimensionCode === "0" ? false : true}
                                cargoResponse={historyEvent}
                                cargoResponseIndex={index}
                                handleListItemClick={handleListItemClick}
                                selectedScanIndex={selectedScanIndex}
                                openDetailsModal={openDetailsModal}
                                machine={machine}
                            />
                        )
                    }
                    else if (historyEvent instanceof TextEventProps) {
                        return <TextEvent key={index}  {...historyEvent} />
                    }
                    else if (historyEvent instanceof MachineEvent && !historyEvent.complete) {
                        return <ScanSkeleton key={index} ></ScanSkeleton>
                    }
                    else {
                        return undefined // Unknown history event type
                    }
                })
            }
        </List>
    )
}

export default React.memo(ScanHistory);